import { createApp } from "vue";
import App from "./App.vue";
import router from "./router.js";
import "./styles/base.css";
import "./styles/admin-ui.css";
import "./styles/withdrawals.css";
import "./styles/overview.css";
createApp(App).use(router).mount("#app");
